let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("acuGh")).then(() => parcelRequire('iPYeg'));